import { useContextState } from "../../../../../../hooks/theme"


export const useStyles = () => {
  const { colors: color } = useContextState()
  return {
    userSelected: ({ haveUser }: { haveUser: boolean }) => ({    //listoo
      color: haveUser ? color.color1 : color.color13,
      '&.MuiTypography-root': {
        fontSize: '14px'
      }
    }),
    permissionTable: (payload: { loading: boolean }) => ({   //listoo
      //padding: '20px',
      //paddingBottom: '0px',
      ...!!payload.loading && {
        position: 'relative',
        top: '25%'
      }
    }),
    delete: {
      /* position: "relative",
      bottom: '-15px',
      left: '-5px', */
      fontSize: '14px',
      /* '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      }, */
      color: 'white',
      marginRight: '10px',
      '&.MuiButtonBase-root':{
        backgroundColor: color.color31,
        /* transition: 'all 0.3s ease', */
        '&:hover': { 
          fontSize: '13px',
          transform: 'scale(0.99)', 
        },
      }
    },
    flex: {   //listoo
      display: 'flex',
      alignItems: 'center',
      gap:2
    },
    goBack: {   //listoo
      display: 'flex',
      justifyContent: 'flex-start',
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem',
        color: color.color4,
      },
      marginBottom: '20px'
    },
    alignItems: {   //listoo
      width: '100%',
      alignItems: 'center',
      justifyContent: 'end',
      marginRight: 2,
      /* '& .MuiTypography-root': {
        fontSize: '14px'
      } */
    },
  }
}
